<template>
  <div class="">
    <v-container>
      <v-row>
        <v-col
          v-for="doc in documentsList"
          :key="doc.document_kind"
          md="4"
          sm="6"
          cols="12"
          class="d-flex justify-center"
        >
          <FileInput
            :status="doc.status"
            :personId="record.id"
            :label="$t(`main.enums.documents.${doc.document_kind}`)"
            :type="doc.document_kind"
            :required="doc.required"
            :creationDate="doc.created_at"
            :supportingDocuments="supportingDocuments(doc.document_kind)"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script type="text/javascript">
  import mixinUi from '@/mixins/utils/ui.js'
  import CommonMixin from '@/mixins/store/CommonMixin.js'
  import mixinCurrency from '@/mixins/utils/currency.js'
  import { uniqBy } from '@/utils/common.utils'

  import FileInput from '@/components/ui/inputs/FileInput'

  export default {
    components: {
      FileInput,
    },
    mixins: [mixinUi, CommonMixin, mixinCurrency,],
    data() {
      return {
        record: {},
      }
    },
    computed: {
      documentsList() {
        const requiredDocs = this.requiredDocuments.map((x) => x)
        if (!!this.record.tax_country && this.record.tax_country !== 'FRANCE') {
          requiredDocs.push({ document_kind: 'proof_of_tax_address', })
        }
        if (['mandataire_client', 'mandataire_tiers',].includes(this.record.person_kind)) {
          requiredDocs.push({ document_kind: 'proxy_mandate', })
        }
        const uniqDocs = this.record.supporting_documents
          ? uniqBy(this.record.supporting_documents, (i) => i.document_kind)
          : []

        return requiredDocs.map((doc) => {
          const lastDoc = uniqDocs.filter((item) => item.document_kind === doc.document_kind)
          if (
            lastDoc.length > 0 &&
            lastDoc[0].document_kind === doc.document_kind &&
            lastDoc[0].pages.length > 0
          ) {
            doc.created_at = lastDoc[0].created_at
            doc.status = lastDoc[0].status
          } else {
            doc.status = 'empty'
          }
          doc.required = !!requiredDocs.find((item) => item.document_kind === doc.document_kind)
          doc.required = !['proof_of_tax_address', 'proxy_mandate',].includes(doc.document_kind)

          return doc
        })
      },
    },
    mounted() {
      this.record = Object.assign({}, this.selectedProfile)
    },
    methods: {
      supportingDocuments(documentKind) {
        const supportingDocuments = this.record.supporting_documents || []
        const filteredList = supportingDocuments.filter((item) => item.document_kind === documentKind)

        return filteredList[0] || {}
      },
      getRecord() {
        return this.record
      },
    },
  }
</script>
